import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import {
  Toolbar,
  Box,
  Button,
  Badge,
  CircularProgress,
  Tooltip,
  Grid,
  AlertColor,
  Card,
  styled,
  autocompleteClasses,
} from '@mui/material';
import * as yup from 'yup';
import TitleText from '../components/formlib/TitleText';
import { ReactComponent as Filtericon } from '../assets/images/FilterIconsvg.svg';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useNavigate } from 'react-router';
import {
  getAllReferrals,
  getClientsDetails,
  getListByRole,
  ReferralResponseType,
} from '../services/configApi/Clients';
import { ClientsFilterType, ClientsListType, OptionType } from '../utils/type';
import SnackBarComponent from '../components/formlib/SnackBarComponent';
import MediumTypography from '../components/formlib/MediumTypography';
import SearchBox from '../components/formlib/SearchBox';
import dayjs, { Dayjs } from 'dayjs';
import { encodeURI } from 'js-base64';
import DatePickerComponent from '../components/formlib/DatePickerComponent';
import SelectComponent from '../components/formlib/SelectComponent';
import ButtonComponent from '../components/formlib/ButtonComponent';
import { Formik, FormikProps } from 'formik';
import './ClientsDashboardPage.css';
import { CLIENT_NAME_KEY, REFERRAL_ID_KEY } from '../services/Constant';
import { right } from '@popperjs/core';
import SearchNotFound from '../components/formlib/SearchNotFound';
import { debounce } from 'lodash';
import { FACESHEET } from '../routes/Routing';
import { LoaderContext, LoaderContextType } from '../layouts/AppSidebar';
import { FormattedMessage } from 'react-intl';
import DisplayFilter, { FilterBy } from '../components/shared/DisplayFilter';
import EmptyScreen from '../components/shared/EmptyScreen';
import { visuallyHidden } from '@mui/utils';
import { ApiError, isCustomError } from '../services/ApiResponseHandler';
import AppPagination from '../components/shared/AppPagination';
import { checkPermissionForFeature } from '../utils/checkPermission';
import {
  calculateMonths,
  datePickerMinDateMaxDateValidate,
} from '../utils/dateUtil';
import { LookUpContext } from '../context/LookUpContextProvider';
import AutocompleteSearch from '../components/formlib/AutocompleteSearch';
import CheckBoxComponent from '../components/formlib/CheckBoxComponent';
import { clearClientStorageDetails } from '../utils/utilities';
import { formatName } from '../utils/nameUtils';
import CustomMenu from '../components/formlib/CustomMenu';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import {
  setClientListFilters,
  resetClientListFilters,
} from '../redux/features/clientList/clientListFilterSlice';
import { store } from '../redux/store';
type Order = 'asc' | 'desc';

type HeadCell = {
  disablePadding: boolean;
  id: keyof Data;
  label: string;
  numeric: boolean;
  requiredSorting: boolean;
};

const headCells: readonly HeadCell[] = [
  {
    id: 'lastName',
    numeric: false,
    disablePadding: true,
    label: 'Client Name',
    requiredSorting: true,
  },
  {
    id: 'dphId',
    numeric: true,
    disablePadding: false,
    label: 'Enrollment ID',
    requiredSorting: false,
  },
  {
    id: 'dateOfBirth',
    numeric: true,
    disablePadding: false,
    label: 'Date of Birth',
    requiredSorting: true,
  },
  {
    id: 'dateOfBirth',
    numeric: true,
    disablePadding: false,
    label: 'Age',
    requiredSorting: true,
  },
  {
    id: 'ifspDueDate',
    numeric: true,
    disablePadding: false,
    label: 'IFSP Due Date',
    requiredSorting: true,
  },
  {
    id: 'intakeFacilitator',
    numeric: true,
    disablePadding: false,
    label: 'Intake facilitator',
    requiredSorting: false,
  },
  {
    id: 'serviceCoordinator',
    numeric: true,
    disablePadding: false,
    label: 'Service Coordinator',
    requiredSorting: false,
  },
  {
    id: 'Status',
    numeric: true,
    disablePadding: false,
    label: 'Status',
    requiredSorting: false,
  },
];
export type Data = {
  sno: string;
  lastName: string;
  dateOfBirth: string;
  dphId: string;
  ifspDueDate: string;
  intakeFacilitator: string;
  serviceCoordinator: string;
  Status: string;
  editElipses: string;
  dateOfBirthInYears: string;
};

const initialFilterValues: ClientsFilterType = {
  birthStartDate: null,
  birthEndDate: null,
  startDate: null,
  endDate: null,
  startAge: '',
  endAge: '',
  ifspDueStartDate: null,
  ifspDueEndDate: null,
  serviceCoordinator: '',
  assesmentStartHour: '',
  assesmentEndHour: '',
  status: '',
  ageMonthStart: '',
  ageMonthEnd: '',
  intakeFacilitator: '',
  noIntakeFacilitator: '',
  noServiceCoordinator: '',
};

interface EnhancedTableProps {
  onRequestSort: (
    event: React.MouseEvent<unknown>,
    property: keyof Data,
  ) => void;
  order: Order;
  orderBy: string;
}
function EnhancedTableHead(props: Readonly<EnhancedTableProps>) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler =
    (property: keyof Data, requiredSort: boolean) =>
    (event: React.MouseEvent<unknown>) => {
      if (requiredSort) {
        onRequestSort(event, property);
      }
    };

  return (
    <TableHead className="listDataTableHead">
      <TableRow>
        <TableCell padding="checkbox">
          <CheckBoxComponent ischecked={false} />
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              onClick={createSortHandler(headCell.id, headCell.requiredSorting)}
              className="Tableheaderstyle"
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              hideSortIcon={!headCell.requiredSorting}
              sx={{
                cursor: headCell.requiredSorting ? 'pointer' : 'default',
                pointerEvents: headCell.requiredSorting ? 'auto' : 'none',
                '& .MuiButtonBase-root': {
                  cursor: headCell.requiredSorting ? 'pointer' : 'default',
                },
              }}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
const CustomBadge = styled(Badge)(({ color }: { color?: string }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: color ?? '#37D183',
    height: '8px',
    width: '8px',
    top: 0,
    bottom: 0,
    marginRight: '10px',
  },
}));

const ClientsDashboardPage = () => {
  const [showEmptyScreen, setShowEmptyScreen] = useState<boolean>(false);
  const [order, setOrder] = useState<Order>('asc');
  const [clientDetails, setClientDetails] = useState<ClientsListType[]>([]);
  const [clientDetailsCount, setClientDetailsCount] = useState<number>(0);
  const [open, setOpen] = React.useState(false);
  const formRef = React.useRef<FormikProps<ClientsFilterType>>(null);
  const [orderBy, setOrderBy] = useState<keyof Data>('ifspDueDate');
  const [toastrVariable, setToastrVariable] =
    React.useState<AlertColor>('info');
  const [loader, setloader] = useState(false);
  const [searchquery, setSearchquery] = useState('');
  const [filterBy, setFilterBy] = React.useState<FilterBy[]>([]);
  const MemorizedCustomMenu = useMemo(() => CustomMenu, []);
  const [toastrDefaultMessage, setToastrDefaultMessage] = React.useState('');
  const [toastrId, setToastrId] = React.useState('');
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const { toggleLoader } = React.useContext(LoaderContext) as LoaderContextType;
  const [serviceCoordinatorsList, setServiceCoordinatorsList] = useState<
    OptionType[]
  >([]);
  const [intakeCoordinatorsList, setIntakeCoordinatorsList] = useState<
    OptionType[]
  >([]);
  const [selectedCoordinator, setSelectedCoordinator] = useState<
    OptionType | null | undefined
  >();

  const [selectedIntakeCoordinator, setSelectedIntakeCoordinator] = useState<
    OptionType | null | undefined
  >();

  const [roleBasedInactiveEmployees, setRoleBasedInactiveEmployees] = useState<{
    selectedServiceCoordinatorIds: string[];
    selectedIntakeFacilitatorIds: string[];
  }>({
    selectedServiceCoordinatorIds: [],
    selectedIntakeFacilitatorIds: [],
  });
  console.log('roleBasedInactiveEmployees', roleBasedInactiveEmployees);
  const { lookupsDemographics, updateDemographics } = useContext(LookUpContext);

  const [filterPlainData, setFilterPlainData] =
    React.useState<ClientsFilterType>(initialFilterValues);
  const dispatch = useAppDispatch();
  const filters = useAppSelector((state) => state.clientFilter);
  const openit = Boolean(anchorEl);
  const handlefilter = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handlefilterClose = () => {
    setAnchorEl(null);
  };
  const PostApplyFilter = () => {
    setAnchorEl(null);
  };
  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: keyof Data,
  ) => {
    setOrder(order === 'asc' ? 'desc' : 'asc');
    setOrderBy(property);
  };
  useEffect(() => {
    // Keep form state in sync with Redux
    setFilterPlainData(filters);

    // 1️⃣ Build DisplayFilter data
    const filterDataBy: FilterBy[] = [];

    if (filters.birthStartDate) {
      filterDataBy.push({
        key: 'Clientpage.dateofbirth',
        value: `${filters.birthStartDate} - ${filters.birthEndDate}`,
      });
    }

    if (filters.startAge) {
      filterDataBy.push({
        key: 'ageText',
        value: `${filters.ageMonthStart} - ${filters.ageMonthEnd}`,
      });
    }
    if (filters.ifspDueEndDate) {
      filterDataBy.push({
        key: 'Facesheet.ifspDueDate',
        value: `${filters.ifspDueStartDate} - ${filters.ifspDueEndDate}`,
      });
    }
    if (filters.assesmentEndHour) {
      filterDataBy.push({
        key: 'Clientpage.AssessmentHoursText',
        value: `${getTimeBasedStringValue(
          filters.assesmentStartHour,
        )} - ${getTimeBasedStringValue(filters.assesmentEndHour)}`,
      });
    }
    if (filters.status) {
      filterDataBy.push({
        key: 'Dashboard.Status',
        value: filters.status,
      });
    }
    if (filters.intakeFacilitator) {
      filterDataBy.push({
        key: 'Facesheet.intakeFacilitator',
        value: filters.intakeFacilitator,
      });
    }
    if (filters.serviceCoordinator) {
      filterDataBy.push({
        key: 'Facesheet.serviceCoordinator',
        value: filters.serviceCoordinator,
      });
    }
    if (filters.noIntakeFacilitator === 'true') {
      filterDataBy.push({
        key: 'noIntakeFacilitator',
        value: filters.noIntakeFacilitator,
      });
    }
    if (filters.noServiceCoordinator === 'true') {
      filterDataBy.push({
        key: 'noServiceCoordinator',
        value: filters.noServiceCoordinator,
      });
    }

    // 2️⃣ Apply cleanup rule
    if (
      filterDataBy.length <= 2 &&
      filterDataBy.some((item) => item.value === 'false')
    ) {
      clearForm();
      setFilterBy([]);
      return; // skip API call if clearing
    }

    setFilterBy(filterDataBy);

    // 3️⃣ Build encoded string
    const encodedAge = `dateOfBirth>=${filters.endAge}&dateOfBirth<=${filters.startAge}`;
    const encodedifspduedate = `&ifspDueDate>=${
      filters.ifspDueStartDate ?? ''
    }&ifspDueDate<=${filters.ifspDueEndDate ?? ''}`;
    const encodedStatus = `&status=${filters.status}`;
    const encodedIntakeFacilitator = `&intakeFacilitator=${filters.intakeFacilitator}`;
    const encodedServiceCoordinator = `&serviceCoordinator=${filters.serviceCoordinator}`;
    const encodedNoIntakeFacilitator = `&noIntakeFacilitator=${filters.noIntakeFacilitator}`;
    const encodedNoServiceCoordinator = `&noServiceCoordinator=${filters.noServiceCoordinator}`;
    const encodedDob = `&birthStartDate=${
      filters.birthStartDate ?? ''
    }&birthEndDate=${filters.birthEndDate ?? ''}`;
    const totalEncodedValue = encodeURI(
      `${encodedAge}${encodedifspduedate}${encodedStatus}${encodedIntakeFacilitator}${encodedServiceCoordinator}${encodedNoIntakeFacilitator}${encodedNoServiceCoordinator}${encodedDob}`,
    );

    // 4️⃣ Fetch data
    // sessionStorage.clear();
    clearClientStorageDetails();
    toggleLoader(true);
    getClientsDetails(
      filters.pageNo ?? 0,
      10,
      totalEncodedValue,
      orderBy,
      order,
      searchquery,
    )
      .then(async (response) => {
        const uniqueIntakeFacilitatorsIds: string[] = [
          ...new Set(
            response.clients
              .map((client) => client.intakeFacilitator)
              .filter((id) => id && id.trim() !== ''),
          ),
        ];

        const uniqueServiceCoordinatorIds: string[] = [
          ...new Set(
            response.clients
              .map((client) => client.serviceCoordinator)
              .filter((id) => id && id.trim() !== ''),
          ),
        ];

        await handleServiceCoordinatorsList(uniqueServiceCoordinatorIds);
        await handleIntakeCoordinatorsList(uniqueIntakeFacilitatorsIds);

        toggleLoader(false);
        setClientDetails(response.clients);
        setClientDetailsCount(response.totalClientsCount);
        setShowEmptyScreen(
          response.totalClientsCount === 0 &&
            filters.pageNo === 0 &&
            searchquery === '',
        );
        setloader(false);
        PostApplyFilter();
      })
      .catch((error) => {
        setOpen(true);
        toggleLoader(false);
        setToastrVariable('error');
        if (isCustomError(error)) {
          const apiError = error as ApiError;
          setToastrId(apiError.id);
          setToastrDefaultMessage(apiError.message);
        } else {
          setToastrId('loadFailureMessage');
          setToastrDefaultMessage('Failed to get details');
        }
      });
  }, [filters, order, orderBy, searchquery]);

  const handleServiceCoordinatorsList = async (empIds?: string[]) => {
    const serviceCoordinatorsDetails = await getListByRole(
      'backend.role.service_coordinator',
      empIds,
    );
    setRoleBasedInactiveEmployees((prev) => ({
      ...prev,
      selectedServiceCoordinatorIds:
        serviceCoordinatorsDetails
          ?.filter((obj) => obj.isInActive)
          .map((obj) => obj.id) ?? [],
    }));

    if (!serviceCoordinatorsDetails) return;
    const serviceCoList: OptionType[] = [];
    serviceCoordinatorsDetails.forEach((coordinator) => {
      serviceCoList.push({
        id: coordinator.id,
        label: formatName(
          coordinator.firstName,
          null,
          coordinator.lastName,
          null,
        ),
      });
    });
    setServiceCoordinatorsList(serviceCoList);
  };

  const handleIntakeCoordinatorsList = async (empIds?: string[]) => {
    const intakeCoordinatorsDetails = await getListByRole(
      'backend.role.intake_coordinator',
      empIds,
    );

    setRoleBasedInactiveEmployees((prev) => ({
      ...prev,
      selectedIntakeFacilitatorIds:
        intakeCoordinatorsDetails
          ?.filter((obj) => obj.isInActive)
          .map((obj) => obj.id) ?? [],
    }));

    if (!intakeCoordinatorsDetails) return;
    const intakeCoList: OptionType[] = [];
    intakeCoordinatorsDetails.forEach((coordinator) => {
      intakeCoList.push({
        id: coordinator.id,
        label: formatName(
          coordinator.firstName,
          null,
          coordinator.lastName,
          null,
        ),
      });
    });
    setIntakeCoordinatorsList(intakeCoList);
  };

  const clearForm = () => {
    dispatch(resetClientListFilters());
    formRef.current?.resetForm();
    setFilterPlainData(initialFilterValues);
    setFilterBy([]);
    setAnchorEl(null);
  };
  const validationSchema = yup.object().shape({
    birthStartDate: yup
      .string()
      .nullable()
      .test(
        'required-if-birth-end-date',
        'Dashboard.dobStartDate',
        (value, context) => {
          const { birthEndDate } = context.parent;
          if (birthEndDate && !value) {
            return false;
          }
          return true;
        },
      ),

    birthEndDate: yup
      .string()
      .nullable()
      .test(
        'required-if-birth-start-date',
        'Dashboard.dobEndDate',
        (value, context) => {
          const { birthStartDate } = context.parent;
          if (birthStartDate && !value) {
            return false;
          }
          return true;
        },
      ),
    startAge: yup.string(),
    ageMonthEnd: yup.string().when('startAge', {
      is: (startAge: string) => !!startAge,
      then: yup.string().required('Dashboard.endAge').nullable(),
      otherwise: yup.string().nullable(),
    }),
    ifspDueStartDate: yup
      .string()
      .nullable()
      .test(
        'required-if-end-date',
        'Dashboard.ifspDueStarttDate',
        (value, context) => {
          const { ifspDueEndDate } = context.parent;
          if (ifspDueEndDate && !value) {
            return false;
          }
          return true;
        },
      ),
    ifspDueEndDate: yup
      .string()
      .nullable()
      .test(
        'required-if-start-date',
        'Dashboard.ifspDueEndDate',
        (value, context) => {
          const { ifspDueStartDate } = context.parent;
          if (ifspDueStartDate && !value) {
            return false;
          }
          return true;
        },
      ),
    serviceCoordinator: yup.string(),
    assesmentStartHour: yup.string(),
    assesmentEndHour: yup.string().when('assesmentStartHour', {
      is: (assesmentStartHour: string) => !!assesmentStartHour,
      then: yup.string().required('Dashboard.assesmentEndHour').nullable(),
      otherwise: yup.string().nullable(),
    }),
    status: yup.string(),
  });
  const validateForm = (value: ClientsFilterType) => {
    const errors: Partial<ClientsFilterType> = {};
    if (dayjs(value.ifspDueEndDate).isBefore(dayjs(value.ifspDueStartDate))) {
      errors.ifspDueEndDate = 'endDateGreaterThanStartDate';
    }
    if (datePickerMinDateMaxDateValidate(value.ifspDueStartDate)) {
      errors.ifspDueStartDate = 'datePickerMinDateMaxDateValidate';
    }
    if (datePickerMinDateMaxDateValidate(value.ifspDueEndDate)) {
      errors.ifspDueEndDate = 'datePickerMinDateMaxDateValidate';
    }
    if (dayjs(value.birthEndDate).isBefore(dayjs(value.birthStartDate))) {
      errors.birthEndDate = 'endDateGreaterThanStartDate';
    }
    if (datePickerMinDateMaxDateValidate(value.birthStartDate)) {
      errors.birthStartDate = 'datePickerMinDateMaxDateValidate';
    }
    if (datePickerMinDateMaxDateValidate(value.birthEndDate)) {
      errors.birthEndDate = 'datePickerMinDateMaxDateValidate';
    }
    return errors;
  };

  const getAllReferralsBasedOnSelectedClient = async (
    clientId: string,
    defaultReferralId: string,
  ) => {
    toggleLoader(true);
    if (clientId) {
      await getAllReferrals(clientId, defaultReferralId)
        .then(async (response: ReferralResponseType[]) => {
          if (response) {
            localStorage.setItem(
              'clientReferralDetails',
              JSON.stringify(response),
            );
          }
          navigation(FACESHEET, { state: { clientId } });

          toggleLoader(false);
        })
        .catch((error) => {
          navigation(FACESHEET, { state: { clientId } });

          toggleLoader(false);
          if (isCustomError(error)) {
            const apiError = error as ApiError;
            setToastrVariable('error');
            setToastrId(apiError.id);
            setToastrDefaultMessage(apiError.message);
          } else {
            setToastrVariable('error');
            setToastrId('failedClientReferralDetailsMessage');
            setToastrDefaultMessage('Failed to load client referral details');
          }
        });
    }
  };

  const handleClick = async (
    clientId: string,
    clientName: string,
    referralId: string,
  ) => {
    localStorage.setItem('ClientId', clientId);
    localStorage.setItem(CLIENT_NAME_KEY, clientName);

    if (lookupsDemographics) {
      updateDemographics({
        ...lookupsDemographics,
        firstName: '',
        middleName: '',
        lastName: '',
        suffix: '',
        ageInMonths: null,
        sex: null,
        dateOfBirth: '',
        dphId: null,
      });
    }
    localStorage.setItem(REFERRAL_ID_KEY, referralId);
    getAllReferralsBasedOnSelectedClient(clientId, referralId);
  };

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const navigation = useNavigate();

  const navigateToReferralCreation = () => {
    navigation('/referral-dashboard/add-referral');
  };

  const isValidInput = (value: string) => {
    const allowedCharacters = /^[a-zA-Z0-9,'.\s!-]*$/;
    return allowedCharacters.test(value);
  };

  const handleSearchChange = useCallback(
    debounce((value: string) => {
      if (isValidInput(value)) {
        dispatch(
          setClientListFilters({ ...store.getState().clientFilter, pageNo: 0 }),
        );
        setSearchquery(value);
      } else {
        setOpen(true);
        setToastrVariable('error');
        setToastrId('Dashboard.ClientList.searchError');
        setToastrDefaultMessage(
          'Only alphanumeric characters, commas, periods, spaces, exclamation marks, and hyphens are allowed to be searched.',
        );
      }
    }, 500),
    [],
  );

  const ClientStatus = ['Active', 'Inactive', 'Pending'];
  const encoded = (values: ClientsFilterType) => {
    if (deepEqual(filterPlainData, values)) {
      return;
    }

    dispatch(
      setClientListFilters({
        ...values,
        pageNo: 0,
      }),
    );

    setFilterPlainData(values);
  };

  const getTimeBasedStringValue = (selectedValue: string) => {
    if (selectedValue) {
      const filteredValue: string =
        +selectedValue > 9
          ? selectedValue.concat(':00')
          : '0'.concat(selectedValue.concat(':00'));
      return filteredValue;
    }
  };

  const dateBuilder = (usermonth: string) => {
    const month = parseInt(usermonth);
    const currentDate = new Date();

    // Calculate the birth date by subtracting the age in months from the current date
    const birthDate = new Date(
      currentDate.setMonth(currentDate.getMonth() - month),
    );
    // Format the birth date in mm/dd/yyyy format
    const formattedBirthDate = `${String(birthDate.getMonth() + 1).padStart(
      2,
      '0',
    )}/${String(birthDate.getDate()).padStart(
      2,
      '0',
    )}/${birthDate.getFullYear()}`;
    return formattedBirthDate;
  };
  const badgePicker = (status: string) => {
    switch (status) {
      case 'Inactive':
        return (
          <CustomBadge
            variant="dot"
            sx={{
              '& .MuiBadge-badge': {
                backgroundColor: 'red',
              },
            }}
          />
        );
      case 'Pending':
        return (
          <CustomBadge
            variant="dot"
            sx={{
              '& .MuiBadge-badge': {
                backgroundColor: '#FFA500',
              },
            }}
          />
        );
      default:
        return <CustomBadge variant="dot" />;
    }
  };

  const stringsArray = Array.from({ length: 37 }, (_, index) =>
    index.toString(),
  );
  const generateNumberOptions = (start: number, end: number) => {
    return stringsArray.slice(start, end + 1);
  };

  const getServiceCoordinator = (serviceCoordinator: string) => {
    const displayServiceCoordinator = serviceCoordinatorsList.filter(
      (obj) => obj.id === serviceCoordinator,
    );

    return displayServiceCoordinator.length > 0
      ? displayServiceCoordinator.map((obj) => obj.label)
      : '-';
  };

  const getIntakeFacilitator = (intakeFacilitator: string) => {
    const displayIntakeFacilitator = intakeCoordinatorsList.filter(
      (obj) => obj.id === intakeFacilitator,
    );

    return displayIntakeFacilitator.length > 0
      ? displayIntakeFacilitator.map((obj) => obj.label)
      : '-';
  };

  function deepEqual(
    obj1: ClientsFilterType,
    obj2: ClientsFilterType,
  ): boolean {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  }

  const resetCoordinatorsByKey = (key: string | undefined) => {
    if (key === 'Facesheet.intakeFacilitator') {
      setSelectedIntakeCoordinator(null);
    }
    if (key === 'Facesheet.serviceCoordinator') {
      setSelectedCoordinator(null);
    }
  };

  const shouldClearField = (
    filterKey: string,
    removedKey: string | undefined,
  ): boolean => {
    return filterKey === removedKey;
  };

  const buildUpdatedFilters = (
    removedKey: string | undefined,
  ): ClientsFilterType => {
    const isDobRemoved = shouldClearField('Clientpage.dateofbirth', removedKey);
    const isAgeRemoved = shouldClearField('ageText', removedKey);
    const isIfspRemoved = shouldClearField('Facesheet.ifspDueDate', removedKey);
    const isAssessmentRemoved = shouldClearField(
      'Clientpage.AssessmentHoursText',
      removedKey,
    );
    const isStatusRemoved = shouldClearField('Dashboard.Status', removedKey);
    const isIntakeFacilitatorRemoved = shouldClearField(
      'Facesheet.intakeFacilitator',
      removedKey,
    );
    const isServiceCoordinatorRemoved = shouldClearField(
      'Facesheet.serviceCoordinator',
      removedKey,
    );
    const isNoIntakeFacilitatorRemoved = shouldClearField(
      'noIntakeFacilitator',
      removedKey,
    );
    const isNoServiceCoordinatorRemoved = shouldClearField(
      'noServiceCoordinator',
      removedKey,
    );

    return {
      birthStartDate: isDobRemoved ? null : filterPlainData.birthStartDate,
      birthEndDate: isDobRemoved ? null : filterPlainData.birthEndDate,
      startDate: filterPlainData.startDate,
      endDate: filterPlainData.endDate,
      startAge: isAgeRemoved ? '' : filterPlainData.startAge,
      endAge: isAgeRemoved ? '' : filterPlainData.endAge,
      ifspDueStartDate: isIfspRemoved ? null : filterPlainData.ifspDueStartDate,
      ifspDueEndDate: isIfspRemoved ? null : filterPlainData.ifspDueEndDate,
      assesmentStartHour: isAssessmentRemoved
        ? ''
        : filterPlainData.assesmentStartHour,
      assesmentEndHour: isAssessmentRemoved
        ? ''
        : filterPlainData.assesmentEndHour,
      status: isStatusRemoved ? '' : filterPlainData.status,
      ageMonthStart: isAgeRemoved ? '' : filterPlainData.ageMonthStart,
      ageMonthEnd: isAgeRemoved ? '' : filterPlainData.ageMonthEnd,
      intakeFacilitator: isIntakeFacilitatorRemoved
        ? ''
        : filterPlainData.intakeFacilitator,
      serviceCoordinator: isServiceCoordinatorRemoved
        ? ''
        : filterPlainData.serviceCoordinator,
      noIntakeFacilitator: isNoIntakeFacilitatorRemoved
        ? ''
        : filterPlainData.noIntakeFacilitator,
      noServiceCoordinator: isNoServiceCoordinatorRemoved
        ? ''
        : filterPlainData.noServiceCoordinator,
    };
  };

  const handleFilterClose = (index: number, key: string | undefined) => {
    resetCoordinatorsByKey(key);

    if (filterBy.length < 2) {
      clearForm();
    } else {
      const updatedFilters = buildUpdatedFilters(key);
      encoded(updatedFilters);
      setFilterBy(filterBy.filter((_, i) => i !== index));
    }
  };

  return (
    <>
      <SnackBarComponent
        open={open}
        handleClose={handleClose}
        successOrError={toastrVariable}
        labelId={toastrId}
        defaultMessageId={toastrDefaultMessage}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: '#E7F0F0',
          padding: '24px',
        }}
      >
        <Toolbar disableGutters>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
                alignItems: 'center',
              }}
            >
              <Box sx={{ flexGrow: 1 }}>
                <TitleText
                  labelid="Dashboard.ClientList"
                  defaultlabel="Client List"
                />
              </Box>
              <Box sx={{ flexGrow: 0 }}>
                <SearchBox
                  labelId="Clientdashboard.searchText"
                  defaultlabel="Search Client"
                  onChange={handleSearchChange}
                />
              </Box>
              <Box
                sx={{
                  flexGrow: 0,
                  mx: '16px',
                }}
              >
                <Button
                  className="btn-primary btn-filter"
                  variant="outlined"
                  onClick={handlefilter}
                  endIcon={<KeyboardArrowDownIcon />}
                  startIcon={<Filtericon />}
                >
                  <FormattedMessage id="FiterText" defaultMessage="Filter" />
                </Button>
                <MemorizedCustomMenu
                  id="demo-customized-menu"
                  anchorEl={anchorEl}
                  open={openit}
                  onClose={handlefilterClose}
                >
                  <Formik
                    innerRef={formRef}
                    initialValues={filterPlainData}
                    enableReinitialize
                    validationSchema={validationSchema}
                    onSubmit={(values) => {
                      encoded(values);
                    }}
                    validate={validateForm}
                  >
                    {({
                      setFieldValue,
                      handleSubmit,
                      errors,
                      touched,
                      values,
                    }) => (
                      <Grid container rowSpacing={2} columnSpacing={2}>
                        <Grid item xs={5.5}>
                          <DatePickerComponent
                            name="ifspDueStartDate"
                            value={
                              values.birthStartDate !== null
                                ? dayjs(values.birthStartDate)
                                : null
                            }
                            labelid="Clientpage.dateofbirth"
                            defaultlabelid="Date of Birth"
                            handlechange={(date: Dayjs | null) => {
                              const formattedDate =
                                dayjs(date).format('MM/DD/YYYY');
                              if (date === null) {
                                setFieldValue('birthStartDate', null);
                              } else {
                                setFieldValue('birthStartDate', formattedDate);
                              }
                              if (
                                values &&
                                values.birthEndDate !== null &&
                                values.birthEndDate > formattedDate
                              ) {
                                setFieldValue('birthEndDate', null);
                              }
                              setFieldValue('birthEndDate', null);
                            }}
                          />
                          {errors.birthStartDate && touched.birthStartDate && (
                            <MediumTypography
                              labelid={errors.birthStartDate}
                              textColor="red"
                              marginTop="8px"
                            />
                          )}
                        </Grid>
                        <Grid item xs={1}>
                          <MediumTypography
                            labelid="Dashboard.to"
                            defaultlabel="to"
                            sxProps={{
                              textAlign: 'center',
                              margin: 'revert',
                            }}
                          />
                        </Grid>
                        <Grid item xs={5.5}>
                          <DatePickerComponent
                            name="birthEndDate"
                            value={
                              values.birthEndDate !== null
                                ? dayjs(values.birthEndDate)
                                : null
                            }
                            minDate={dayjs(values.birthStartDate)}
                            labelid="Clientpage.dateofbirth"
                            defaultlabelid="Date of Birth"
                            handlechange={(date: Dayjs | null) => {
                              const formattedDate =
                                dayjs(date).format('MM/DD/YYYY');
                              if (date === null) {
                                setFieldValue('birthEndDate', null);
                              } else {
                                setFieldValue('birthEndDate', formattedDate);
                              }
                            }}
                          />
                          {errors.birthEndDate && touched.birthEndDate && (
                            <MediumTypography
                              labelid={errors.birthEndDate}
                              textColor="red"
                              marginTop="8px"
                            />
                          )}
                        </Grid>
                        <Grid item xs={5.5} display={'none'}>
                          <SelectComponent
                            labelid="Dashboard.startDate"
                            defaultlabelid="Age"
                            name="startAge"
                            value={values.ageMonthStart}
                            handleChange={(value: string) => {
                              setFieldValue('endAge', '');
                              setFieldValue('startAge', dateBuilder(value));
                              setFieldValue('ageMonthStart', value);
                              setFieldValue('ageMonthEnd', '');
                            }}
                            names={generateNumberOptions(0, 36)}
                          />
                        </Grid>
                        <Grid item xs={1} display={'none'}>
                          <MediumTypography
                            labelid="Dashboard.to"
                            defaultlabel="to"
                            sxProps={{
                              textAlign: 'center',
                              margin: 'revert',
                            }}
                          />
                        </Grid>
                        <Grid item xs={5.5} display={'none'}>
                          <SelectComponent
                            labelid="Dashboard.endDate"
                            defaultlabelid="Age"
                            name="endAge"
                            value={values.ageMonthEnd}
                            handleChange={(value: string) => {
                              if (values.ageMonthStart !== '') {
                                setFieldValue('endAge', dateBuilder(value));
                                setFieldValue('ageMonthEnd', value);
                              }
                            }}
                            names={generateNumberOptions(
                              Number(values.ageMonthStart),
                              36,
                            )}
                          />
                          {errors.ageMonthEnd && touched.ageMonthEnd && (
                            <MediumTypography
                              labelid={errors.ageMonthEnd}
                              textColor="red"
                              marginTop="8px"
                            />
                          )}
                        </Grid>
                        <Grid item xs={5.5}>
                          <DatePickerComponent
                            name="ifspDueStartDate"
                            value={
                              values.ifspDueStartDate !== null
                                ? dayjs(values.ifspDueStartDate)
                                : null
                            }
                            labelid="Dashboard.ifspDueStartDate"
                            defaultlabelid="IFSP Due Start Date"
                            handlechange={(date: Dayjs | null) => {
                              const formattedDate =
                                dayjs(date).format('MM/DD/YYYY');
                              if (date === null) {
                                setFieldValue('ifspDueStartDate', null);
                              } else {
                                setFieldValue(
                                  'ifspDueStartDate',
                                  formattedDate,
                                );
                              }
                              if (
                                values &&
                                values.ifspDueEndDate !== null &&
                                values.ifspDueEndDate > formattedDate
                              ) {
                                setFieldValue('ifspDueEndDate', null);
                              }
                              setFieldValue('ifspDueEndDate', null);
                            }}
                          />
                          {errors.ifspDueStartDate &&
                            touched.ifspDueStartDate && (
                              <MediumTypography
                                labelid={errors.ifspDueStartDate}
                                textColor="red"
                                marginTop="8px"
                              />
                            )}
                        </Grid>
                        <Grid item xs={1}>
                          <MediumTypography
                            labelid="Dashboard.to"
                            defaultlabel="to"
                            sxProps={{
                              textAlign: 'center',
                              margin: 'revert',
                            }}
                          />
                        </Grid>
                        <Grid item xs={5.5}>
                          <DatePickerComponent
                            name="ifspDueEndDate"
                            value={
                              values.ifspDueEndDate !== null
                                ? dayjs(values.ifspDueEndDate)
                                : null
                            }
                            minDate={dayjs(values.ifspDueStartDate)}
                            labelid="Dashboard.ifspDueEndtDate"
                            defaultlabelid="IFSP Due End Date"
                            handlechange={(date: Dayjs | null) => {
                              const formattedDate =
                                dayjs(date).format('MM/DD/YYYY');
                              if (date === null) {
                                setFieldValue('ifspDueEndDate', null);
                              } else {
                                setFieldValue('ifspDueEndDate', formattedDate);
                              }
                            }}
                          />
                          {errors.ifspDueEndDate && touched.ifspDueEndDate && (
                            <MediumTypography
                              labelid={errors.ifspDueEndDate}
                              textColor="red"
                              marginTop="8px"
                            />
                          )}
                        </Grid>
                        <Grid item xs={5.5} style={{ display: 'none' }}>
                          <SelectComponent
                            labelid="Dashboard.Assessmentstart"
                            defaultlabelid="Assessment Hours"
                            name="assesmentStartHour"
                            value={values.assesmentStartHour}
                            handleChange={(value: string) => {
                              setFieldValue('assesmentStartHour', value);
                              setFieldValue('assesmentEndHour', '');
                            }}
                            names={generateNumberOptions(1, 19)}
                          />
                        </Grid>
                        <Grid item xs={1} style={{ display: 'none' }}>
                          <MediumTypography
                            labelid="Dashboard.to"
                            defaultlabel="to"
                            sxProps={{
                              textAlign: 'center',
                              margin: 'revert',
                            }}
                          />
                        </Grid>
                        <Grid item xs={5.5} style={{ display: 'none' }}>
                          <SelectComponent
                            labelid="Dashboard.Assessmentend"
                            defaultlabelid="Assessment Hours"
                            name="assesmentEndHour"
                            value={values.assesmentEndHour}
                            handleChange={(value: string) => {
                              if (values.assesmentStartHour !== '') {
                                setFieldValue('assesmentEndHour', value);
                              }
                            }}
                            names={generateNumberOptions(
                              Number(values.assesmentStartHour) + 1,
                              20,
                            )}
                          />

                          {errors.assesmentEndHour &&
                            touched.assesmentEndHour && (
                              <MediumTypography
                                labelid={errors.assesmentEndHour}
                                textColor="red"
                                marginTop="8px"
                              />
                            )}
                        </Grid>
                        <Grid item xs={5.5} className="pt-none">
                          <Box>
                            <CheckBoxComponent
                              name="noIntakeFacilitator"
                              labelid="noIntakeFacilitator"
                              defaultlabelid="No Intake Facilitator"
                              ischecked={values.noIntakeFacilitator === 'true'}
                              CheckHandleChange={(
                                event: React.ChangeEvent<HTMLInputElement>,
                              ) => {
                                const checked =
                                  event.target.checked === true
                                    ? 'true'
                                    : 'false';
                                setFieldValue('noIntakeFacilitator', checked);
                                setSelectedIntakeCoordinator(null);
                                setFieldValue('intakeFacilitator', '');
                              }}
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={1}>
                          <MediumTypography
                            labelid=""
                            defaultlabel=""
                            sxProps={{
                              textAlign: 'center',
                              margin: 'revert',
                            }}
                          />
                        </Grid>
                        <Grid item xs={5.5} className="pt-none">
                          <Box>
                            <CheckBoxComponent
                              className="box_child_label_mr0"
                              name="noServiceCoordinator"
                              labelid="noServiceCoordinator"
                              defaultlabelid="No Service Coordinator"
                              ischecked={values.noServiceCoordinator === 'true'}
                              CheckHandleChange={(
                                event: React.ChangeEvent<HTMLInputElement>,
                              ) => {
                                const checked =
                                  event.target.checked === true
                                    ? 'true'
                                    : 'false';
                                setFieldValue('noServiceCoordinator', checked);
                                setSelectedCoordinator(null);
                                setFieldValue('serviceCoordinator', '');
                              }}
                            />
                          </Box>
                        </Grid>

                        <Grid item xs={5.5} className="pt-md">
                          <AutocompleteSearch
                            disabled={values.noIntakeFacilitator == 'true'}
                            labelId={'Facesheet.intakeFacilitator'}
                            defaultId="Intake Facilitator"
                            optionHintId={'nointakeDropdownTextId'}
                            sxProps={{
                              [`& .${autocompleteClasses.popupIndicator}`]: {
                                transform: 'none',
                              },
                            }}
                            data={intakeCoordinatorsList.filter(
                              (item) =>
                                !roleBasedInactiveEmployees.selectedIntakeFacilitatorIds.includes(
                                  item.id,
                                ),
                            )}
                            selectedValue={selectedIntakeCoordinator ?? null}
                            onSelectItem={(value: OptionType | null) => {
                              setFieldValue(
                                'intakeFacilitator',
                                value ? value.id : '',
                              );
                              setSelectedIntakeCoordinator(value);
                            }}
                            disableLabel={false}
                          />
                        </Grid>

                        <Grid item xs={1}></Grid>
                        <Grid item xs={5.5} className="pt-md">
                          <AutocompleteSearch
                            disabled={values.noServiceCoordinator == 'true'}
                            labelId={'Facesheet.serviceCoordinator'}
                            defaultId="Service Coordinator"
                            optionHintId={'noserviceDropdownTextId'}
                            sxProps={{
                              [`& .${autocompleteClasses.popupIndicator}`]: {
                                transform: 'none',
                              },
                            }}
                            data={serviceCoordinatorsList.filter(
                              (item) =>
                                !roleBasedInactiveEmployees.selectedServiceCoordinatorIds.includes(
                                  item.id,
                                ),
                            )}
                            selectedValue={selectedCoordinator ?? null}
                            onSelectItem={(value: OptionType | null) => {
                              setFieldValue(
                                'serviceCoordinator',
                                value ? value.id : '',
                              );
                              setSelectedCoordinator(value);
                            }}
                            disableLabel={false}
                          />
                        </Grid>

                        <Grid item xs={12}>
                          <SelectComponent
                            labelid="Dashboard.Status"
                            defaultlabelid="Status"
                            name="status"
                            value={values.status}
                            handleChange={(value: string) => {
                              setFieldValue('status', value);
                            }}
                            names={ClientStatus}
                          />
                        </Grid>

                        <Grid item xs={12} textAlign={right} mt={1.5}>
                          <Box
                            sx={{ justifyContent: 'right', display: 'flex' }}
                          >
                            <Box className="mr-md">
                              <ButtonComponent
                                className="btn-primary btn-cancel btn_width_90px"
                                variantType="contained"
                                labelId="Dashboard.filtercancel"
                                defaultLabelId="Cancel"
                                onClick={() => {
                                  encoded(initialFilterValues);
                                  setFilterPlainData(initialFilterValues);
                                  setSelectedCoordinator(null);
                                  setSelectedIntakeCoordinator(null);
                                  setAnchorEl(null);
                                }}
                                disabled={loader}
                              />
                            </Box>
                            <Box>
                              <ButtonComponent
                                className="btn-primary btn-submit btn_width_90px"
                                variantType="contained"
                                type="submit"
                                labelId="Dashboard.filtersubmit"
                                defaultLabelId="Apply"
                                onClick={() => {
                                  if (deepEqual(filterPlainData, values)) {
                                    return;
                                  }
                                  handleSubmit();
                                }}
                              />
                            </Box>
                          </Box>
                        </Grid>
                      </Grid>
                    )}
                  </Formik>
                </MemorizedCustomMenu>
              </Box>
              <Box sx={{ flexGrow: 0 }}>
                <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                  {checkPermissionForFeature(
                    'backend.referral_dashboard',
                    'addPermission',
                  ) && (
                    <ButtonComponent
                      className="btn-primary btn-submit"
                      variantType="contained"
                      type="submit"
                      labelId="Referraldashboard.AddTitletext"
                      defaultLabelId="Add New Referral"
                      onClick={() => navigateToReferralCreation()}
                    />
                  )}
                </Box>
              </Box>
            </Box>
            {filterBy.length > 0 && (
              <DisplayFilter
                filteredData={filterBy}
                selectedIntakeFacilitator={selectedIntakeCoordinator}
                selectedServiceCoordinator={selectedCoordinator}
                handleCloseClick={handleFilterClose}
                handleClearClick={() => {
                  setSelectedIntakeCoordinator(null);
                  setSelectedCoordinator(null);
                  clearForm();
                }}
              />
            )}
          </Box>
        </Toolbar>

        {/* No Clients Added */}
        {showEmptyScreen && filterBy.length === 0 && searchquery === '' && (
          <EmptyScreen
            titleLabelId="noClientsMessage"
            defaultTitleText="No Clients added yet."
            buttonLabelId="Referraldashboard.AddTitletext"
            defaultButtonTitleText="Add New Referral"
            showButton={true}
            onButtonClick={() => navigateToReferralCreation()}
          />
        )}

        {/* Filters applied but no results */}
        {filterBy.length > 0 &&
          clientDetails.length === 0 &&
          showEmptyScreen && <SearchNotFound />}

        {/* Searching but no results */}
        {searchquery !== '' && clientDetails.length === 0 && <SearchNotFound />}

        {clientDetailsCount !== 0 && clientDetails.length !== 0 && (
          <Box>
            <Card sx={{ width: '100%' }}>
              <TableContainer>
                {loader && (
                  <Box
                    sx={{
                      position: 'absolute',
                      left: '55%',
                      marginTop: '5%',
                      top: '50%',
                    }}
                  >
                    <CircularProgress sx={{ color: '#00938E' }} />
                  </Box>
                )}
                <Table
                  sx={{ minWidth: 750, maxWidth: '100%' }}
                  aria-labelledby="tableTitle"
                  size={'medium'}
                >
                  <EnhancedTableHead
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                  />
                  <TableBody className="tableRowcss">
                    {clientDetails?.map((row, indexRow) => {
                      return (
                        <TableRow
                          hover
                          onClick={() => {
                            handleClick(
                              row.clientId,
                              `${formatName(
                                row.firstName,
                                row.middleName,
                                row.lastName,
                                row.suffix,
                              )}`,
                              row.referralId,
                            );
                          }}
                          tabIndex={-1}
                          key={indexRow + row.clientId}
                          sx={{
                            cursor: 'pointer',
                            alignContent: 'flex-start',
                            '&:nth-of-type(odd)': {
                              backgroundColor: '#ECF9F8',
                            },
                          }}
                        >
                          <TableCell padding="checkbox">
                            <CheckBoxComponent ischecked={false} />
                          </TableCell>
                          <Tooltip
                            id="tool-tip"
                            arrow
                            followCursor
                            title={formatName(
                              row.firstName,
                              row.middleName,
                              row.lastName,
                              row.suffix,
                            )}
                            placement="top"
                          >
                            <TableCell
                              className="cursorPointer"
                              sx={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                maxWidth: '100px',
                                fontFamily: 'Lato-Regular',
                                color: 'rgb(0, 140, 130) !important',
                              }}
                            >
                              {`${formatName(
                                row.firstName,
                                row.middleName,
                                row.lastName,
                                row.suffix,
                              )}`}
                            </TableCell>
                          </Tooltip>

                          <TableCell
                            className="cursorPointer"
                            sx={{
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              maxWidth: '100px',
                              fontFamily: 'Lato-Regular',
                            }}
                          >
                            {row.dphId ? row.dphId.toUpperCase() : '-'}
                          </TableCell>

                          <TableCell
                            className="cursorPointer"
                            sx={{
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              maxWidth: '100px',
                              fontFamily: 'Lato-Regular',
                            }}
                          >
                            {row.dateOfBirth}
                          </TableCell>

                          <Tooltip
                            className="cursorPointer"
                            id="tool-tip"
                            arrow
                            followCursor
                            title={calculateMonths(row.dateOfBirth)
                              .replace('(', ', ')
                              .replace(')', '')}
                            placement="top"
                          >
                            <TableCell
                              className="cursorPointer"
                              sx={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                maxWidth: '100px',
                                fontFamily: 'Lato-Regular',
                              }}
                            >
                              {calculateMonths(row.dateOfBirth)
                                .replace('(', ', ')
                                .replace(')', '')}
                            </TableCell>
                          </Tooltip>

                          <TableCell
                            className="cursorPointer"
                            sx={{
                              fontFamily: 'Lato-Regular',
                            }}
                          >
                            {row.ifspDueDate ? row.ifspDueDate : '-'}
                          </TableCell>

                          <Tooltip
                            className="cursorPointer"
                            id="tool-tip"
                            arrow
                            followCursor
                            title={getIntakeFacilitator(row.intakeFacilitator)}
                            placement="top"
                          >
                            <TableCell
                              className="cursorPointer"
                              sx={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                maxWidth: '100px',
                                fontFamily: 'Lato-Regular',
                              }}
                            >
                              {getIntakeFacilitator(row.intakeFacilitator)}
                            </TableCell>
                          </Tooltip>
                          <Tooltip
                            className="cursorPointer"
                            id="tool-tip"
                            arrow
                            followCursor
                            title={getServiceCoordinator(
                              row.serviceCoordinator,
                            )}
                            placement="top"
                          >
                            <TableCell
                              sx={{
                                fontFamily: 'Lato-Regular',
                              }}
                            >
                              {getServiceCoordinator(row.serviceCoordinator)}
                            </TableCell>
                          </Tooltip>
                          <TableCell
                            className="cursorPointer"
                            sx={{
                              fontFamily: 'Lato-Regular',
                            }}
                          >
                            <Box className="ml-sm">
                              {badgePicker(row.status)}
                              {row.status}
                            </Box>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Card>

            {clientDetailsCount > 10 && (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <AppPagination
                  pageNumber={filters.pageNo || 0}
                  paginationCount={clientDetailsCount}
                  handleChangePage={(_event, newPage) => {
                    if (newPage - 1 !== filters.pageNo) {
                      dispatch(
                        setClientListFilters({
                          ...filters,
                          pageNo: newPage - 1,
                        }),
                      );
                    }
                  }}
                />
              </Box>
            )}
          </Box>
        )}
      </Box>
    </>
  );
};

export default ClientsDashboardPage;
